import { useState, useEffect, useMemo } from "react";

const pad = (n) => String(n).padStart(2, "0");

function useCountdown(targetISO) {
  const target = useMemo(() => new Date(targetISO).getTime(), [targetISO]);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const diff = Math.max(0, target - now);
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    mins: Math.floor((diff % 3600000) / 60000),
    secs: Math.floor((diff % 60000) / 1000),
    ended: diff === 0,
  };
}

export function Countdown({ targetISO, liveLabel, testId = "countdown", compact = false }) {
  const cd = useCountdown(targetISO);

  if (cd.ended) {
    return (
      <div
        className="inline-flex items-center justify-center rounded-2xl bg-electric text-white px-8 py-5 font-anton text-2xl md:text-3xl uppercase tracking-wide"
        data-testid={`${testId}-live`}
      >
        {liveLabel}
      </div>
    );
  }

  const units = [
    { v: cd.days, l: "Días" },
    { v: cd.hours, l: "Horas" },
    { v: cd.mins, l: "Min" },
    { v: cd.secs, l: "Seg" },
  ];

  return (
    <div
      className={`grid grid-cols-4 gap-3 md:gap-5 ${compact ? "max-w-xl" : "max-w-2xl mx-auto"}`}
      data-testid={testId}
    >
      {units.map((u) => (
        <div
          key={u.l}
          className={`rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-sm text-center ${
            compact ? "py-4 md:py-5" : "py-6 md:py-8"
          }`}
        >
          <div
            className={`font-anton text-white leading-none tabular-nums ${
              compact ? "text-3xl md:text-5xl" : "text-4xl md:text-6xl lg:text-7xl"
            }`}
            data-testid={`${testId}-${u.l.toLowerCase()}`}
          >
            {pad(u.v)}
          </div>
          <div className="font-poppins text-[10px] md:text-sm tracking-[0.22em] uppercase text-electric mt-2">
            {u.l}
          </div>
        </div>
      ))}
    </div>
  );
}
